import config from '@app/config';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { getBannerByPage } from '../services/getBannerByPage';
import { BannerSchema, BannerType } from '../types/bannerSchema';

const initialState: BannerSchema = {
  banners: [],
  isLoaded: false,
};

export const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    setBanners: (state, action: PayloadAction<BannerType[]>) => {
      state.banners = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.banner,
      };
    });
    builder.addCase(getBannerByPage.fulfilled, (state, action) => {
      if (action.payload) {
        state.banners = action.payload.slice(0, 1).map(banner => {
          return {
            name: banner.name,
            erid: banner.erid,
            href: banner.href || null,
            code: banner.code,
            imageDesktop: !banner.desktopSrc?.includes('http') ? `${config.baseImageUrl}/${banner.desktopSrc}` : banner.desktopSrc,
            imageMobile: !banner.mobileSrc?.includes('http') ? `${config.baseImageUrl}/${banner.mobileSrc}` : banner.mobileSrc,
            options: {
              widthDesktop: banner.desktopWidth || null,
              widthMobile: banner.mobileWidth || null,
              heightDesktop: banner.desktopHeight || null,
              heightMobile: banner.mobileHeight || null,
            },
          };
        });
      }
      state.isLoaded = true;
    });
  },
});

export const { actions: bannerActions } = bannerSlice;
